var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "addToSlider" }, [
    _c("header", { staticClass: "b-shadow-1" }, [
      _c("figure", [_c("img", { attrs: { src: _vm.project.image } })]),
      _vm._v(" "),
      _c(
        "div",
        { class: ["sector-en-typeactiviteit", _vm.headerBgColorClass] },
        [
          _c("h2", { class: _vm.headerBgIconClass }, [
            _vm._v(_vm._s(_vm.project._mapping_project_typeactiviteit[0]))
          ])
        ]
      ),
      _vm._v(" "),
      _c("h1", [_vm._v(_vm._s(_vm.project.post_title))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.project._mapping_project_toelichting))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sectoren b-shadow-1" }, [
      _c("h2", { class: _vm.sectorenBgIconClass }, [
        _vm._v(_vm._s(_vm.project._mapping_project_sector[0]))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "summary" }, [
      _vm.project._mapping_project_organisatie
        ? _c("p", { staticClass: "summary_organisatie" }, [
            _vm._v(_vm._s(_vm.project._mapping_project_organisatie))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.project._mapping_project_webpagina
        ? _c("p", { staticClass: "summary_webpagina" }, [
            _c(
              "a",
              {
                staticClass: "btn",
                attrs: {
                  href: _vm.project._mapping_project_webpagina,
                  target: "_mappingnhn"
                }
              },
              [_vm._v(_vm._s(_vm.project._mapping_project_webpagina))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.adres
        ? _c("p", {
            staticClass: "summary_adres",
            domProps: { innerHTML: _vm._s(_vm.adres) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.project._mapping_project_beschrijvingvaneenaantal
        ? _c("p", { staticClass: "summary_beschrijvingvaneenaantal" }, [
            _vm._v(
              _vm._s(_vm.project._mapping_project_beschrijvingvaneenaantal)
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.project._mapping_project_financiëring
        ? _c("p", { staticClass: "summary_financiering" }, [
            _vm._v(_vm._s(_vm.project._mapping_project_financiëring))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.onsnetwerk
        ? _c("p", {
            staticClass: "summary_onsnetwerk",
            domProps: { innerHTML: _vm._s(_vm.onsnetwerk) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "summary_id" }, [
        _vm._v("project ID: " + _vm._s(_vm.project._mapping_project_id))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib?{}!./scripts/vue/PanelDetailProject.vue?vue&type=template&id=c14b34d0&
// module id = 91
// module chunks = 0